module.exports = __webpack_public_path__ + "static/img/rank_289.244d61e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_289.png
// module id = UrR6
// module chunks = 0